import type { PropsWithChildren, ReactNode } from 'react'
import * as NavigationMenu from '@radix-ui/react-navigation-menu'
import { Icon } from '@sunwebgroup/uds-ui/icon'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { Children } from 'react'
import styles from './NestedSubMenu.module.css'
import { SubMenu, type SubMenuProps } from './SubMenu'
import { MenuTrigger } from './Trigger'

export function NestedSubMenu({ children, label }: PropsWithChildren<SubMenuProps>) {
  return (
    <>
      <MenuTrigger onPointerMove={(e: React.PointerEvent) => e.preventDefault()}>
        {label}
        <Icon glyph="ChevronRightExtraSmall" />
      </MenuTrigger>
      <NavigationMenu.Content forceMount>
        <Typography variant="body-m-bold-snug" className={styles.label}>
          {label}
        </Typography>
        <NavigationMenu.Sub className={styles.nestedSubMenu} orientation="vertical">
          <SubMenu.List className={styles.nestedList}>{wrapChildrenWithItem(children)}</SubMenu.List>
          <NavigationMenu.Viewport />
        </NavigationMenu.Sub>
      </NavigationMenu.Content>
    </>
  )
}

function wrapChildrenWithItem(children: ReactNode | ReactNode[]) {
  return Children.map(children, (child, index) => <SubMenu.Item key={index}>{child}</SubMenu.Item>)
}
